var map = {
	"./ARROW/default.svg": "./src/images/cursors/ARROW/default.svg",
	"./ARROW/hover.svg": "./src/images/cursors/ARROW/hover.svg",
	"./ARROW/preview_1.svg": "./src/images/cursors/ARROW/preview_1.svg",
	"./ARROW/preview_2.svg": "./src/images/cursors/ARROW/preview_2.svg",
	"./ARROW/project_hover.svg": "./src/images/cursors/ARROW/project_hover.svg",
	"./BLURRED/default.svg": "./src/images/cursors/BLURRED/default.svg",
	"./BLURRED/hover.svg": "./src/images/cursors/BLURRED/hover.svg",
	"./BLURRED/preview_1.svg": "./src/images/cursors/BLURRED/preview_1.svg",
	"./BLURRED/preview_2.svg": "./src/images/cursors/BLURRED/preview_2.svg",
	"./BLURRED/project_hover_1.svg": "./src/images/cursors/BLURRED/project_hover_1.svg",
	"./BLURRED/project_hover_2.svg": "./src/images/cursors/BLURRED/project_hover_2.svg",
	"./CIRCLE/default.svg": "./src/images/cursors/CIRCLE/default.svg",
	"./CIRCLE/hover.svg": "./src/images/cursors/CIRCLE/hover.svg",
	"./CIRCLE/preview_1.svg": "./src/images/cursors/CIRCLE/preview_1.svg",
	"./CIRCLE/preview_2.svg": "./src/images/cursors/CIRCLE/preview_2.svg",
	"./CIRCLE/project_hover.svg": "./src/images/cursors/CIRCLE/project_hover.svg",
	"./DEFAULT/default.svg": "./src/images/cursors/DEFAULT/default.svg",
	"./DEFAULT/hover.svg": "./src/images/cursors/DEFAULT/hover.svg",
	"./DEFAULT/preview_1.svg": "./src/images/cursors/DEFAULT/preview_1.svg",
	"./DEFAULT/preview_2.svg": "./src/images/cursors/DEFAULT/preview_2.svg",
	"./DEFAULT/project_hover.svg": "./src/images/cursors/DEFAULT/project_hover.svg",
	"./EMOJI/default.svg": "./src/images/cursors/EMOJI/default.svg",
	"./EMOJI/hover.svg": "./src/images/cursors/EMOJI/hover.svg",
	"./EMOJI/preview_1.svg": "./src/images/cursors/EMOJI/preview_1.svg",
	"./EMOJI/preview_2.svg": "./src/images/cursors/EMOJI/preview_2.svg",
	"./EMOJI/project_hover.svg": "./src/images/cursors/EMOJI/project_hover.svg",
	"./FIGMA/default.svg": "./src/images/cursors/FIGMA/default.svg",
	"./FIGMA/hover.svg": "./src/images/cursors/FIGMA/hover.svg",
	"./FIGMA/preview_1.svg": "./src/images/cursors/FIGMA/preview_1.svg",
	"./FIGMA/preview_2.svg": "./src/images/cursors/FIGMA/preview_2.svg",
	"./FIGMA/project_hover.svg": "./src/images/cursors/FIGMA/project_hover.svg",
	"./LABELED/default.svg": "./src/images/cursors/LABELED/default.svg",
	"./LABELED/hover.svg": "./src/images/cursors/LABELED/hover.svg",
	"./LABELED/preview_1.svg": "./src/images/cursors/LABELED/preview_1.svg",
	"./LABELED/preview_2.svg": "./src/images/cursors/LABELED/preview_2.svg",
	"./LABELED/project_hover.svg": "./src/images/cursors/LABELED/project_hover.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/images/cursors sync recursive ^\\.\\/.*\\.svg$";